module.exports = __webpack_public_path__ + "img/app.0620cba5.png";